import React from "react";
import { compose } from "ramda";
import queryString from "query-string";
import { FormikHelpers } from "formik";
import { showToast } from "@deeptrue-frontend/ui";

import Link from "components/RouterProvider/Link";
import Cookies from "js-cookie";
import StoreProvider from "components/StoreProvider/StoreProvider";
import { withMetaDescription } from "components/HeadProvider/HeadProvider";
import { SidePage } from "components/Layout";
import api from "api/api";
import AUTH from "consts/auth";
import signInSplash from "assets/images/sign-in.png";
import SignUpForm, { FormValues } from "./SignUpForm";
import { useFormatMessage } from "components/IntlProvider";
import { Typography, TextLink } from "@deeptrue-frontend/ui";
import { translateFieldErrors } from "components/IntlProvider/translateFieldErrors";
import TagManager from "react-gtm-module";

const { connect, actions } = StoreProvider;

const SignUp = ({ signUp, history: { location } }: any) => {
  const parsedSearch = queryString.parse(location.search);
  const isProduction = process.env.NODE_ENV === "production";

  const t = useFormatMessage();

  const onSubmit = (
    values: FormValues,

    { setSubmitting, setErrors }: FormikHelpers<FormValues>
  ) => {
    return api.resources
      .signUpUser({
        email: values.email,
        password: values.password,
        name: values.name,
        first_name: values.firstName,
        last_name: values.lastName,
        terms_agreement: values.terms_agreement,
        privacy_policy_accepted: values.privacy_policy_accepted,
      })
      .then(({ data }: { data: any }) => {
        TagManager.dataLayer({
          dataLayer: {
            event: "sign_up",
            email: values.email,
            organization_name: values.name,
            first_name: values.firstName,
            last_name: values.lastName,
            date: new Date().toLocaleString(),
          },
        });
        Cookies.set(AUTH.TOKEN, `${data.token}`, {
          path: "/",
          domain: isProduction ? ".deeptrue.com" : "localhost",
        });
        signUp(data);
        setSubmitting(false);

        showToast({
          type: "success",
          title: t(
            "pages.register.success",
            "Message has been sent to the provided email address. Please verify."
          ),
        });
      })
      .catch((err: any) => {
        setErrors(
          translateFieldErrors({
            t,
            err: err.response.data,
          })
        );

        setSubmitting(false);

        if (err.response.status === 401 && err.response.data.show === "yes") {
          showToast({
            type: "success",
            title: err.response.data.detail,
          });
        }
      });
  };

  return (
    <SidePage
      title={t("forms.signup.signup", "Sign up for free.")}
      slogan={
        <Typography color="#fff" mt="6rem" variant="h1">
          {t(
            "forms.signup.pageTitle",
            "After signing up, set up your project within minutes."
          )}
        </Typography>
      }
      splashImage={signInSplash}
    >
      <Typography alignSelf="start" mt="1.5rem" mb="1rem">
        {t("forms.signin.alreadyRegistered", " Already registered?")}
        &nbsp;
        <Link to="/sign-in">
          <TextLink>{t("forms.signin.signinlink", "Sign In")}</TextLink>
        </Link>
      </Typography>
      <SignUpForm
        onSubmit={onSubmit}
        location={location}
        initialValues={{
          email: "",
          password: "",
          passwordRepeat: "",
          firstName: "",
          lastName: "",
          name: parsedSearch.org,
          terms_agreement: false,
          privacy_policy_accepted: false,
        }}
      />
    </SidePage>
  );
};

export default compose(
  connect(null, {
    signUp: actions.authActions.signUp,
  }),
  withMetaDescription({ title: "Dashboard Registration" })
)(SignUp);
